import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/10_card_back_cat_crown/10_card_back_cat_crown"
 * Contains 1 texture(s)
 */
export class CardsBacks10CardBackCatCrownAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/10_card_back_cat_crown/10_card_back_cat_crown';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '10_cat_crown.png'
    ] as const;
}
